import { FC } from "react";
import { QuestionManagementEntry } from "../../store/questionManagement";
import QuestionManagementListItem from "./QuestionManagementListItem";
import { useIsAdmin } from "../../hooks/useIsAdmin";

type QuestionManagementListProps = {
    questionManagementEntries: QuestionManagementEntry[];
    onDelete: (questionManagementEntry: QuestionManagementEntry) => void;
};

const QuestionManagementList: FC<QuestionManagementListProps> = (props) => {
    const { questionManagementEntries } = props;

    const isAdmin = useIsAdmin();

    const handleOnQuestionManagementEntryDelete = (questionManagementEntry: QuestionManagementEntry) => {
        props.onDelete(questionManagementEntry);
    }

    const indexed = questionManagementEntries.map((entry, index) => ({ entry, index }));
    const leftEntries = indexed.filter(item => item.index % 2 === 0);
    const rightEntries = indexed.filter(item => item.index % 2 === 1);

    return (
        <>
            <div className="col half questions-list left-questions">
                <ul>
                    {leftEntries.map(({ entry, index }) =>
                        <QuestionManagementListItem
                            key={index}
                            questionManagementEntry={entry}
                            allowDeletion={isAdmin}
                            onDelete={handleOnQuestionManagementEntryDelete}
                        />
                    )}
                </ul>
            </div>
            <div className="col half questions-list right-questions">
                <ul>
                    {rightEntries.map(({ entry, index }) =>
                        <QuestionManagementListItem
                            key={index}
                            questionManagementEntry={entry}
                            allowDeletion={isAdmin}
                            onDelete={handleOnQuestionManagementEntryDelete}
                        />
                    )}
                </ul>
            </div>
        </>
    );
}

export default QuestionManagementList;